<template>
  <Tabs :value="modelValue" @update:value="$emit('update:modelValue', $event)" :scrollable="scrollable">
    <slot name="tablist"></slot>
    <TabPanels>
      <slot></slot>
    </TabPanels>
  </Tabs>
</template>

<script setup lang="ts">
import Tabs from 'primevue/tabs';
import TabPanels from 'primevue/tabpanels';

withDefaults(defineProps<{
  modelValue?: string | number;
  scrollable?: boolean;
}>(), {
  modelValue: 0,
  scrollable: false,
});

defineEmits<{
  'update:modelValue': [value: string | number];
}>();

defineSlots<{
  tablist(): unknown;
  default(): unknown;
}>();
</script>
